import { FirebaseApp, FirebaseOptions, getApps, initializeApp } from 'firebase/app';

const REMOTE_CONFIG_APP_NAME = 'pw-remote-config';
const SARRTHI_ANALYTICS_APP_NAME = 'sarrthi-analytics';

export function isSarrthiHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const host = window.location?.host;
  if (!host) {
    return false;
  }

  return host.toLowerCase().includes('sarrthiias');
}

const defaultFirebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const sarrthiFirebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_SARRTHI_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_SARRTHI_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_SARRTHI_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_SARRTHI_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_SARRTHI_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_SARRTHI_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_SARRTHI_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_SARRTHI_FIREBASE_MEASUREMENT_ID,
};

export const sarrthiFirebaseVapidKey = process.env.REACT_APP_SARRTHI_FIREBASE_VAPID_KEY;

function getExistingApp(name?: string): FirebaseApp | undefined {
  return getApps().find((app) => app.name === (name ?? '[DEFAULT]'));
}

/** PW Firebase project — used for Remote Config (org_config, feature flags, etc.). */
export function ensureRemoteConfigFirebaseApp(): FirebaseApp {
  const existingApp = getExistingApp(REMOTE_CONFIG_APP_NAME);
  if (existingApp) {
    return existingApp;
  }

  return initializeApp(defaultFirebaseConfig, REMOTE_CONFIG_APP_NAME);
}

/** Host-specific Firebase app for GA / Analytics events. */
export function ensureAnalyticsFirebaseApp(): FirebaseApp {
  if (isSarrthiHost()) {
    const existingSarrthiApp = getExistingApp(SARRTHI_ANALYTICS_APP_NAME);
    if (existingSarrthiApp) {
      return existingSarrthiApp;
    }

    return initializeApp(sarrthiFirebaseConfig, SARRTHI_ANALYTICS_APP_NAME);
  }

  const existingDefaultApp = getExistingApp();
  if (existingDefaultApp) {
    return existingDefaultApp;
  }

  return initializeApp(defaultFirebaseConfig);
}

/** @deprecated Use ensureAnalyticsFirebaseApp or ensureRemoteConfigFirebaseApp */
export function ensureFirebaseApp(): FirebaseApp {
  return ensureAnalyticsFirebaseApp();
}
